/**
 * @author       samuel@zumper.com (Samuel Shih)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  createFallback.js
 */

import React from 'react'

import { Renderable } from './types'

export const createFallback = <Props extends object>(
  fallback?: Renderable<Props>
) => {
  const Fallback = (props: Props) =>
    fallback ? React.createElement(fallback, props) : null
  return Fallback
}
